import { render, staticRenderFns } from "./ColorBlock.vue?vue&type=template&id=6d57f01c&scoped=true&"
import script from "./ColorBlock.vue?vue&type=script&lang=js&"
export * from "./ColorBlock.vue?vue&type=script&lang=js&"
import style0 from "./ColorBlock.vue?vue&type=style&index=0&id=6d57f01c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d57f01c",
  null
  
)

export default component.exports